module.exports = __webpack_public_path__ + "static/media/Arduino.1988d4c9.png";